import { useRequest } from "hooks/useRequest";

export const useInventoryConfigRequester = () => {
	const request = useRequest("InventoryConfig");

	return {
		...request,
	};
};
